// extracted by mini-css-extract-plugin
var _1 = "qoYxg";
export { _1 as "base" }
